import { css } from 'styled-components';
import Colors from '../Styles/Colors';

const _fontFamilySpectral = "'Spectral', serif";
const _fontFamilyMerriweather = "'Merriweather', serif";
const _fontFamilyRoslindale = "'RosVar'";
const _fontFamilyDecotura = "'decotura'";

const Fonts = {
    roslindale: {
        medium: css`
            font-family: ${_fontFamilyRoslindale};
            font-weight: 600;
        `
    },
    spectral: {
        regular: css`
            font-family: ${_fontFamilySpectral};
            font-weight: 400;
        `,
        semibold: css`
            font-family: ${_fontFamilySpectral};
            font-weight: 600;
        `,
        bold: css`
            font-family: ${_fontFamilySpectral};
            font-weight: 700;
        `
    },
    decotura: {
        medium: css`
            font-family: ${_fontFamilyDecotura};
            font-weight: 400;
        `
    },
    merriweather: {
        bold: css`
            font-family: ${_fontFamilyMerriweather};
            font-weight: 700;
        `
    },
    blocks: {
        generalContent: css`
            line-height: 1.3125;
            color: ${Colors.white};

            h1,h2,h3,h4,h5 {
                font-family: ${_fontFamilyMerriweather};
                font-weight: 700;
            };
            h1 {}
            h2 {
                font-size: 29px;
                font-family: ${_fontFamilyDecotura};
                text-transform: uppercase;
                color: ${Colors.goldDark};
            }
            h3 {
                font-size: 16px;
                color: ${Colors.white};
            }

            a {
                color: ${Colors.white};
            }
        `
    }
};

export default Fonts;